import { Box } from '@mui/material';
import { ReactNode } from 'react';
import FlowHeader from './FlowHeader';
import FlowNavigation from './FlowNavigation';
import MobileBottomNavigation from '../sidebar/MobileBottomNavigation';

interface FlowLayoutProps {
    children: ReactNode;
}

const FlowLayout: React.FC<FlowLayoutProps> = ({ children }) => {

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100vh',
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'background.default' : '#ffffff',
            }}
        >
            {/* Header */}
            <FlowHeader />

            {/* Mobile navigation is now always visible at top - no burger menu needed */}

            {/* Navigation */}
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <FlowNavigation />
            </Box>

            {/* Main content */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minHeight: '100vh',
                    bgcolor: (theme) => theme.palette.mode === 'dark' ? 'background.default' : '#ffffff',
                    overflow: 'auto',
                    mt: { xs: 7, sm: 9 }, // Account for fixed header height (56px mobile header)
                    width: '100%', // Full width since navigation is now floating
                    px: { xs: '20px', sm: '0px' }, // Align with chat widget positioning
                    py: { xs: 2, sm: 3 },
                    pb: { xs: '80px', sm: 3 }, // Extra bottom padding on mobile for bottom navigation
                }}
            >
                <Box
                    sx={{
                        mt: { xs: 0, sm: 2 }, // No extra margin needed on mobile - navigation bar handles spacing
                        pt: { xs: 0, sm: 0 },
                        px: 0,
                        maxWidth: '100%',
                        // Align content area with header's 80px padding boundaries
                        // Header: 80px padding + content + 80px padding
                        // Navigation: 80px left + 280px width + gap = 360px + gap
                        // Content should start after navigation with some gap
                        ml: { xs: 0, sm: '420px', md: '420px' }, // 80px + 280px navigation + 60px gap
                        mr: { xs: 0, sm: '80px', md: '80px' }, // Match header's 80px right padding
                    }}
                >
                    {children}
                </Box>
            </Box>

            {/* Mobile bottom navigation */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileBottomNavigation isDisabled={false} />
            </Box>

            {/* No mobile backdrop needed - navigation always visible */}
        </Box>
    );
};

export default FlowLayout;